export default __webpack_public_path__ + "static/media/q14.81a27025.png";